import request from '@/utils/request'


// 根据字典类型查询字典数据信息
export function getDicts(data) {
    console.log(data);

    return request({
        url: '/client/common/getDictData',
        method: 'post',
        data: { key: data }
    })
}